(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hf-gratis-produkt"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var isBlocking    = false;
  var freeGiftKeys  = [];   // { key, variantId }
  var toastTimer    = null;
  var domDebounce   = null;
  var isUpdating    = false;
  var lastCartFP    = '';
  var lastTotal     = 0;    // effektiver Warenkorbwert (ohne Gratis-Artikel)
  var popupShown    = false;

  // ─── Helpers ───────────────────────────────────────────────────────────
  function getSection()  { return document.querySelector('.hf-gp-section'); }
  function getOverlay()  {
    var s = getSection();
    return s ? document.getElementById('hf-gp-overlay-' + s.dataset.sectionId) : null;
  }
  function safeAttr(s) { return String(s).replace(/\\/g, '\\\\').replace(/"/g, '\\"'); }

  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { 'Content-Type': 'application/json' }
    }).then(function (r) { return r.json(); });
  }
  function addToCartAPI(variantId, qty, props) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty, properties: props || {} }] })
    }).then(function (r) { return r.json(); });
  }

  // Discount-Code im Hintergrund anwenden (setzt Shopify-Session-Cookie)
  function applyDiscountCode(code) {
    if (!code) return;
    fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).catch(function () {});
  }

  // ─── Effective total (excl. free gifts) ────────────────────────────────
  function effectiveTotal(cart) {
    var total = cart.total_price;
    cart.items.forEach(function (ci) {
      var p = ci.properties || {};
      if (p['_free_gift'] || p._free_gift) total -= (ci.final_line_price || 0);
    });
    return Math.max(total, 0);
  }

  // ─── Toast ─────────────────────────────────────────────────────────────
  function showToast(ms) {
    var ov = getOverlay(); if (!ov) return;
    ov.removeAttribute('hidden');
    clearTimeout(toastTimer);
    if (ms) toastTimer = setTimeout(function () { ov.setAttribute('hidden', ''); }, ms);
  }
  function hideToast() {
    var ov = getOverlay(); if (ov) ov.setAttribute('hidden', ''); clearTimeout(toastTimer);
  }

  // ─── Checkout blocking ─────────────────────────────────────────────────
  function applyCheckoutState() {
    document.querySelectorAll('[name="checkout"], #checkout').forEach(function (btn) {
      if (isBlocking) {
        btn.disabled = true; btn.setAttribute('data-hf-gp-blocked', 'true');
      } else if (btn.getAttribute('data-hf-gp-blocked') === 'true') {
        btn.disabled = false; btn.removeAttribute('data-hf-gp-blocked');
      }
    });
    document.querySelectorAll(
      'additional-checkout-buttons, shopify-accelerated-checkout-container, .shopify-payment-button__container'
    ).forEach(function (el) {
      var cover = el.querySelector('.hf-gp-accel-cover');
      if (isBlocking) {
        if (!cover) {
          var d = document.createElement('div');
          d.className = 'hf-gp-accel-cover';
          el.style.position = 'relative';
          el.appendChild(d);
        }
      } else if (cover) { cover.remove(); }
    });
  }
  function setBlocking(val) {
    isBlocking = val; applyCheckoutState(); if (!val) hideToast();
  }

  // ─── Capture-phase interceptors ─────────────────────────────────────────
  // FIX: Nur echte Checkout-Submits blockieren – nicht Cart-Update-Formulare
  function initInterceptors() {
    document.addEventListener('submit', function (e) {
      if (!isBlocking) return;
      var form = e.target;
      // e.submitter ist der tatsächlich geklickte Button
      var submitterName = (e.submitter && e.submitter.name) || '';
      // Nur explizit den Checkout-Button oder eine Checkout-Action blocken
      // NICHT blocken wenn kein Submitter bekannt (z.B. Qty-Update via requestSubmit)
      var hasCheckoutBtn = submitterName === 'checkout';
      var actionIsCheckout = !!(form.action && (
        form.action.indexOf('/checkout') !== -1 ||
        form.action.indexOf('checkout.shopify') !== -1
      ));
      if (hasCheckoutBtn || actionIsCheckout) {
        e.preventDefault(); e.stopImmediatePropagation(); showToast(3500);
      }
    }, true);

    document.addEventListener('click', function (e) {
      if (!isBlocking) return;
      if (e.target.closest('[name="checkout"], #checkout')) {
        e.preventDefault(); e.stopImmediatePropagation(); showToast(3500); return;
      }
      if (e.target.closest('a[href*="/checkout"]')) {
        e.preventDefault(); e.stopImmediatePropagation(); showToast(3500);
      }
    }, true);

    document.addEventListener('click', function (e) {
      if (e.target.classList && e.target.classList.contains('hf-gp-accel-cover')) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (isBlocking) showToast(3500);
      }
    }, true);
  }

  // ─── Qty locking + price override in Cart/Drawer ───────────────────────
  function resolveBadgeText(itemEl) {
    var fmt = itemEl ? (itemEl.dataset.badgeFormat || itemEl.dataset.freeLabel || 'GRATIS') : 'GRATIS';
    var min = itemEl ? (itemEl.dataset.minDisplay || '') : '';
    return fmt.replace('{min}', min);
  }

  function overridePriceInContainer(container, badgeText) {
    var selectors = [
      '[class*="cart-item__price"]:not(.hf-gp-free-price-badge)',
      '[class*="cart-item__total"]:not(.hf-gp-free-price-badge)',
      '[class*="cart__price"]:not(.hf-gp-free-price-badge)',
      'td[class*="price"]:not(.hf-gp-free-price-badge)',
      'td.cart-items__price',
      '.price:not(.hf-gp-free-price-badge)',
      '.price__regular',
      '.price__sale',
      '[data-cart-item-price]',
      '[data-regular-price]'
    ].join(', ');
    container.querySelectorAll(selectors).forEach(function (pr) {
      if (pr.getAttribute('data-hf-gp-price-hidden') || pr.classList.contains('hf-gp-free-price-badge')) return;
      pr.setAttribute('data-hf-gp-price-hidden', 'true');
      var badge = document.createElement('span');
      badge.className = 'hf-gp-free-price-badge';
      badge.setAttribute('data-hf-gp-badge', '');
      badge.textContent = badgeText || 'GRATIS';
      pr.parentNode.insertBefore(badge, pr.nextSibling);
    });
  }

  function lockContainer(el, badgeText) {
    if (!el) return;
    // Badge-Text immer aktualisieren
    el.querySelectorAll('[data-hf-gp-badge]').forEach(function(b) {
      b.textContent = badgeText || 'GRATIS';
    });
    // Preis-Override immer aufrufen – deckt Re-Renders des Themes ab
    // (overridePriceInContainer überspringt Elemente die bereits versteckt sind)
    overridePriceInContainer(el, badgeText || 'GRATIS');
    if (el.getAttribute('data-hf-gp-qty-locked') === 'true') return;
    el.setAttribute('data-hf-gp-qty-locked', 'true');
    el.querySelectorAll('[class*="quantity-btn"]').forEach(function (b) {
      b.disabled = true; b.setAttribute('data-hf-gp-qty-btn', '');
    });
    el.querySelectorAll('.quantity-minus, .quantity-plus, button[name="minus"], button[name="plus"]').forEach(function (b) {
      b.disabled = true; b.setAttribute('data-hf-gp-qty-btn', '');
    });
    el.querySelectorAll('input[type="number"]').forEach(function (inp) {
      inp.readOnly = true; inp.setAttribute('data-hf-gp-qty-inp', '');
    });
  }

  function applyQtyLocks() {
    if (!freeGiftKeys.length) return;
    var section = getSection();
    freeGiftKeys.forEach(function (entry) {
      var key = entry.key;
      var vid = String(entry.variantId);
      var badgeText = 'GRATIS';
      if (section) {
        var itemEl = section.querySelector('.hf-gp-item[data-variant-id="' + vid + '"]')
                 || (entry.productId ? section.querySelector('.hf-gp-item[data-product-id="' + entry.productId + '"]') : null);
        if (itemEl) {
          var minCents  = parseInt(itemEl.dataset.minCents, 10) || 0;
          var reached   = lastTotal >= minCents;
          var freeLabel = itemEl.dataset.freeLabel || 'GRATIS';
          var minDisplay = itemEl.dataset.minDisplay || '';
          if (reached) {
            badgeText = freeLabel;
          } else {
            badgeText = minDisplay ? ('Gratis ab\u00a0' + minDisplay) : freeLabel;
          }
        }
      }
      // Strategie 1: data-key (Drawer / die meisten Themes)
      document.querySelectorAll('[data-key="' + safeAttr(key) + '"]').forEach(function (el) {
        lockContainer(el, badgeText);
      });
      // Strategie 2: Cart-Seite (/cart) – updates-Input suchen
      document.querySelectorAll('input[name="updates[' + safeAttr(key) + ']"]').forEach(function (inp) {
        var container = inp.closest('[data-key], [data-variant-id], [class*="cart__item"], [class*="cart-item"], tr, li');
        if (!container) container = inp.parentElement;
        if (container) lockContainer(container, badgeText);
      });
      // Strategie 3: line_item Attribute (Horizon & ähnliche Themes)
      document.querySelectorAll('[data-line-item-key="' + safeAttr(key) + '"], [data-cart-item-key="' + safeAttr(key) + '"]').forEach(function (el) {
        lockContainer(el, badgeText);
      });
    });
  }

  // ─── Listing: Produktkarten ausblenden (ohne Lücke) ────────────────────
  function hideListingProducts() {
    var section = getSection();
    if (!section) return;
    var handles = (section.dataset.hideHandles || '').split(',').map(function(h) { return h.trim(); }).filter(Boolean);
    if (!handles.length) return;

    handles.forEach(function (handle) {
      document.querySelectorAll('a[href*="/products/' + handle + '"]').forEach(function (link) {
        // Traversiere DOM nach oben um das direkte Kind des Grid-/List-Containers zu finden
        var el = link;
        var target = null;
        while (el && el !== document.body) {
          var p = el.parentElement;
          if (!p || p === document.body) break;
          var ptag = (p.tagName || '').toLowerCase();
          var pcls = (typeof p.className === 'string') ? p.className : '';
          // Erkenne Grid-/List-Container
          if (ptag === 'ul' || ptag === 'ol' ||
              /product[_\-]grid|grid[_\-]loop|collection[_\-]list|search[_\-]results|product[_\-]list/i.test(pcls)) {
            target = el;
            break;
          }
          el = p;
        }
        // Fallback: nächstes li oder grid__item
        if (!target) {
          target = link.closest('[class*="grid__item"]') ||
                   link.closest('li') ||
                   link.closest('article');
        }
        if (target) target.classList.add('hf-gp-hidden-product');
      });

      document.querySelectorAll('[data-handle="' + safeAttr(handle) + '"]').forEach(function (el) {
        var target = el.closest('[class*="grid__item"]') || el.closest('li') || el;
        target.classList.add('hf-gp-hidden-product');
      });
    });
  }

  // ─── DOM Watcher ───────────────────────────────────────────────────────
  function refreshCartState() {
    if (isUpdating) return;
    isUpdating = true;
    fetchCart().then(function (cart) {
      isUpdating = false;
      var fp = cart.total_price + '|' + cart.item_count;
      if (fp !== lastCartFP) { lastCartFP = fp; updateSection(cart); }
      else { applyCheckoutState(); applyQtyLocks(); hideListingProducts(); }
    }).catch(function () { isUpdating = false; });
  }

  function initDOMWatcher() {
    var obs = new MutationObserver(function () {
      clearTimeout(domDebounce);
      domDebounce = setTimeout(function () {
        applyCheckoutState(); applyQtyLocks(); applyExpressCheckoutVisibility(); refreshCartState(); hideListingProducts();
      }, 60);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // ─── Varianten-Auswahl ─────────────────────────────────────────────────
  function initVariantSelectors() {
    document.querySelectorAll('.hf-gp-item').forEach(function (item) {
      var dataEl = item.querySelector('.hf-gp-variants-data');
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch(e) { return; }

      var selectedOptions = {};

      item.querySelectorAll('.hf-gp-variant-btn[data-selected="true"]').forEach(function (btn) {
        selectedOptions[btn.dataset.option] = btn.dataset.value;
      });

      function getMatchingVariant() {
        return variants.find(function (v) {
          return v.options.every(function (opt, idx) {
            return selectedOptions[String(idx)] === opt;
          });
        });
      }

      function markAvailability() {
        item.querySelectorAll('.hf-gp-variant-btn').forEach(function (btn) {
          var testOptions = Object.assign({}, selectedOptions);
          testOptions[btn.dataset.option] = btn.dataset.value;
          var match = variants.find(function (v) {
            return v.options.every(function (opt, idx) { return testOptions[String(idx)] === opt; });
          });
          btn.dataset.available = match ? String(match.available) : 'false';
        });
      }

      function updateSelection() {
        var variant = getMatchingVariant();
        var addBtn = item.querySelector('.hf-gp-item__add-btn');
        if (variant) {
          item.dataset.variantId = String(variant.id);
          if (addBtn) {
            if (!variant.available) {
              addBtn.dataset.state = 'unavailable';
            } else if (addBtn.dataset.state === 'unavailable') {
              addBtn.dataset.state = 'idle';
            }
          }
        }
        markAvailability();
      }

      item.querySelectorAll('.hf-gp-variant-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var optionIdx = btn.dataset.option;
          selectedOptions[optionIdx] = btn.dataset.value;
          item.querySelectorAll('.hf-gp-variant-btn[data-option="' + optionIdx + '"]').forEach(function (b) {
            b.removeAttribute('data-selected'); b.setAttribute('aria-pressed', 'false');
          });
          btn.setAttribute('data-selected', 'true'); btn.setAttribute('aria-pressed', 'true');
          updateSelection();
        });
      });

      updateSelection();
    });
  }

  // ─── Popup / Click-Tab ─────────────────────────────────────────────────
  function initPopup() {
    var section = getSection();
    if (!section) return;
    var mode = section.dataset.mode;

    var closeBtn = section.querySelector('.hf-gp-popup-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        section.classList.remove('hf-gp-popup--visible');
        popupShown = true;
        var tabBtn = document.getElementById('hf-gp-tab-' + section.dataset.sectionId);
        if (tabBtn) tabBtn.setAttribute('aria-expanded', 'false');
        try { sessionStorage.setItem('hf_gp_popup_closed', '1'); } catch(e) {}
      });
    }

    if (mode === 'click_tab') {
      var tabBtn = document.getElementById('hf-gp-tab-' + section.dataset.sectionId);
      if (tabBtn) {
        // Vertikale Position des Panels mit dem Tab synchronisieren
        var pos = tabBtn.style.getPropertyValue('--hf-gp-tab-pos') || '50%';
        section.style.setProperty('--hf-gp-tab-panel-pos', pos);

        tabBtn.addEventListener('click', function () {
          var isOpen = section.classList.contains('hf-gp-popup--visible');
          if (isOpen) {
            section.classList.remove('hf-gp-popup--visible');
            tabBtn.setAttribute('aria-expanded', 'false');
          } else {
            section.style.display = '';
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                section.classList.add('hf-gp-popup--visible');
                tabBtn.setAttribute('aria-expanded', 'true');
              });
            });
          }
        });
      }
      return;
    }

    if (mode !== 'popup_timed' && mode !== 'popup_scroll') return;

    try { if (sessionStorage.getItem('hf_gp_popup_closed') === '1') return; } catch(e) {}

    function showPopup() {
      if (popupShown) return;
      popupShown = true;
      section.style.display = '';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { section.classList.add('hf-gp-popup--visible'); });
      });
    }

    if (mode === 'popup_timed') {
      setTimeout(showPopup, (parseFloat(section.dataset.popupDelay) || 3) * 1000);
    } else {
      var pct = parseFloat(section.dataset.popupScroll) || 30;
      function onScroll() {
        var scrolled = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
        if (scrolled >= pct) { window.removeEventListener('scroll', onScroll, { passive: true }); showPopup(); }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  // ─── Express Checkout auf /cart ausblenden ─────────────────────────────
  function applyExpressCheckoutVisibility() {
    var section = getSection();
    if (!section || section.dataset.hideExpress !== 'true') return;

    // Nur auf der Cart-Seite aktiv
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cartPath = (rootPath + 'cart').replace('//', '/');
    var onCartPage = window.location.pathname === cartPath || window.location.pathname === '/cart';
    if (!onCartPage) return;

    // Nur ausblenden wenn: Gratis-Artikel IM Warenkorb liegt UND Mindestbestellwert noch nicht erreicht
    var anyBelowThreshold = false;
    section.querySelectorAll('.hf-gp-item').forEach(function(item) {
      var minCents  = parseInt(item.dataset.minCents, 10) || 0;
      var productId = item.dataset.productId || '';
      var giftInCart = freeGiftKeys.some(function(e) { return e.productId === productId; });
      if (minCents > 0 && lastTotal < minCents && giftInCart) anyBelowThreshold = true;
    });

    // Alle Express-Checkout-Container finden (Shop Pay, Apple Pay, Google Pay, PayPal …)
    var expressSelectors = [
      'additional-checkout-buttons',
      'shopify-accelerated-checkout-container',
      '.shopify-payment-button__container',
      '.cart__dynamic-checkout-buttons',
      '[class*="dynamic-checkout"]',
      '[id*="accelerated-checkout"]'
    ];
    expressSelectors.forEach(function(sel) {
      try {
        document.querySelectorAll(sel).forEach(function(el) {
          // Nicht unsere eigenen Elemente anfassen
          if (section.contains(el)) return;
          if (anyBelowThreshold) {
            el.classList.add('hf-gp-express-hidden');
          } else {
            el.classList.remove('hf-gp-express-hidden');
          }
        });
      } catch(e) {}
    });
  }

  // ─── Zwischensumme überschreiben (Gratis-Artikel abziehen) ────────────
  function updateCartTotals(cart) {
    var section = getSection();
    if (!section || section.dataset.hideGiftFromTotal !== 'true') return;
    var effective = effectiveTotal(cart);
    var selStr = section.dataset.subtotalSelectors || "[class*='drawer-subtotal-price']";
    var sels = selStr.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
    sels.forEach(function(sel) {
      try {
        document.querySelectorAll(sel).forEach(function(el) {
          if (section.contains(el)) return; // eigene Elemente ignorieren
          var formatted;
          try {
            if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
              var fmt = window.Shopify.money_with_currency_format
                     || window.Shopify.money_format
                     || '{{amount_with_comma_separator}} EUR';
              formatted = window.Shopify.formatMoney(effective, fmt);
            }
          } catch(e2) {}
          if (!formatted) {
            formatted = (effective / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
          }
          el.textContent = formatted;
        });
      } catch(e) {}
    });
  }

  // ─── Section UI update ─────────────────────────────────────────────────
  function updateSection(cart) {
    var section = getSection();
    if (!section) return;

    var total = effectiveTotal(cart);
    lastTotal = total;
    var anyBlocking = false;

    freeGiftKeys = [];
    cart.items.forEach(function (ci) {
      var p = ci.properties || {};
      if (p['_free_gift'] || p._free_gift) freeGiftKeys.push({ key: ci.key, variantId: ci.variant_id, productId: String(ci.product_id || ''), originalPrice: ci.original_price || 0 });
    });

    section.querySelectorAll('.hf-gp-item').forEach(function (item) {
      var minCents  = parseInt(item.dataset.minCents, 10) || 0;
      var variantId = String(item.dataset.variantId);
      var maxQty    = parseInt(item.dataset.maxQty, 10) || 1;
      var blocksCo  = item.dataset.blockCheckout === 'true';
      var reached   = total >= minCents;

      // Gesamtmenge über alle Varianten dieses Produkts zählen (muss VOR Nutzung stehen)
      var productId = item.dataset.productId || '';
      var cartQty = 0;
      cart.items.forEach(function (ci) {
        var p = ci.properties || {};
        if ((p['_free_gift'] || p._free_gift) && String(ci.product_id) === productId) {
          cartQty += ci.quantity;
        }
      });
      var maxReached = cartQty >= maxQty;

      var fill = item.querySelector('.hf-gp-item__bar-fill');
      if (fill) fill.style.setProperty('--fill', (minCents > 0 ? Math.min((total / minCents) * 100, 100) : 100) + '%');

      var st = item.querySelector('.hf-gp-item__status-text');
      if (st) {
        var diff = minCents - total;
        st.textContent = diff > 0
          ? 'Noch ' + (diff / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac bis zu deinem Gratis-Produkt'
          : 'Mindestbestellwert erreicht \u2713';
      }

      var card = item.querySelector('.hf-gp-item__product');
      if (card) reached ? card.removeAttribute('hidden') : card.setAttribute('hidden', '');

      var msg = item.querySelector('.hf-gp-item__blocked-msg');
      // Sperrhinweis: sichtbar wenn Gratis-Produkt im Warenkorb liegt, aber Mindestbestellwert noch nicht erreicht
      if (msg) (cartQty > 0 && !reached && blocksCo) ? msg.removeAttribute('hidden') : msg.setAttribute('hidden', '');

      // Blockieren NUR wenn: Gratis-Produkt im Warenkorb UND Mindestbestellwert noch NICHT erreicht
      if (blocksCo && cartQty > 0 && !reached) anyBlocking = true;

      var addBtn = item.querySelector('.hf-gp-item__add-btn');
      if (addBtn) {
        var txtEl  = addBtn.querySelector('.hf-gp-item__add-btn-text');
        var doneEl = addBtn.querySelector('.hf-gp-item__add-btn-added');
        if (reached && maxReached) {
          addBtn.dataset.state = 'added';
          if (txtEl) txtEl.setAttribute('hidden', '');
          if (doneEl) doneEl.removeAttribute('hidden');
        } else if (!reached || addBtn.dataset.state !== 'unavailable') {
          addBtn.dataset.state = reached ? 'idle' : 'idle';
          if (txtEl) txtEl.removeAttribute('hidden');
          if (doneEl) doneEl.setAttribute('hidden', '');
        }
      }
    });

    setBlocking(anyBlocking);
    setTimeout(applyQtyLocks, 80);
    setTimeout(applyQtyLocks, 400);
    setTimeout(applyQtyLocks, 1000);
    setTimeout(applyQtyLocks, 2000);
    updateCartTotals(cart);
    applyExpressCheckoutVisibility();

    var mode = section.dataset.mode;
    if (mode === 'inline') section.style.display = '';
  }

  // ─── Add-buttons ───────────────────────────────────────────────────────
  function bindAddButtons() {
    var section = getSection();
    if (!section) return;
    section.querySelectorAll('.hf-gp-item__add-btn').forEach(function (btn) {
      if (btn.dataset.hfGpBound) return;
      btn.dataset.hfGpBound = 'true';
      btn.addEventListener('click', function () {
        var item         = btn.closest('.hf-gp-item');
        var vid          = parseInt(item.dataset.variantId, 10);
        var maxQty       = parseInt(item.dataset.maxQty, 10) || 1;
        var productId    = item.dataset.productId || '';
        var discCode     = item.dataset.discountCode || '';
        var checkStock   = item.dataset.checkStock === 'true';
        var handle       = item.dataset.productHandle || '';
        var soldOutLabel = item.dataset.soldOutLabel || 'Leider ausverkauft';
        if (!vid) return;

        btn.dataset.state = 'loading';

        // Lagerbestand live prüfen falls aktiviert
        var stockCheck = (checkStock && handle)
          ? checkProductSoldOut(handle)
          : Promise.resolve(false);

        stockCheck.then(function (soldOut) {
          if (soldOut) {
            btn.dataset.state = 'sold_out';
            var txtEl = btn.querySelector('.hf-gp-item__add-btn-text');
            if (txtEl) txtEl.textContent = soldOutLabel;
            btn.disabled = true;
            return Promise.reject('sold_out');
          }
        }).then(function () { return fetchCart(); }).then(function (cart) {
          // Zähle ALLE Gratis-Varianten dieses Produkts im Warenkorb
          var currentQty = 0;
          cart.items.forEach(function (ci) {
            var p = ci.properties || {};
            if ((p['_free_gift'] || p._free_gift) && String(ci.product_id) === productId) {
              currentQty += ci.quantity;
            }
          });

          if (currentQty >= maxQty) {
            var txtEl  = btn.querySelector('.hf-gp-item__add-btn-text');
            var doneEl = btn.querySelector('.hf-gp-item__add-btn-added');
            btn.dataset.state = 'added';
            if (txtEl) txtEl.setAttribute('hidden', '');
            if (doneEl) doneEl.removeAttribute('hidden');
            return Promise.resolve(cart);
          }

          return addToCartAPI(vid, maxQty - currentQty, { _free_gift: 'true' }).then(function () {
            // Rabattcode im Hintergrund anwenden
            if (discCode) applyDiscountCode(discCode);
            var txtEl  = btn.querySelector('.hf-gp-item__add-btn-text');
            var doneEl = btn.querySelector('.hf-gp-item__add-btn-added');
            btn.dataset.state = 'added';
            if (txtEl) txtEl.setAttribute('hidden', '');
            if (doneEl) doneEl.removeAttribute('hidden');
            return fetchCart();
          });
        })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          updateSection(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function (err) { if (err !== 'sold_out') btn.dataset.state = 'idle'; });
      });
    });
  }

  // ─── Lagerbestand live prüfen ──────────────────────────────────────────
  // Gibt ein Promise<bool> zurück: true = ausverkauft, false = verfügbar.
  // Prüft /products/{handle}.js – frisch vom Shopify-Server, nicht aus Cache.
  function checkProductSoldOut(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p.variants || !p.variants.length) return false;
        return p.variants.every(function (v) { return !v.available; });
      })
      .catch(function () { return false; }); // Bei Fehler → nicht sperren
  }

  // Zeigt das Modal nur wenn Lager ok, sonst Ausverkauft-Overlay.
  function openGratisModal(item) {
    var checkStock  = item.dataset.checkStock === 'true';
    var handle      = item.dataset.productHandle || '';
    var soldOutLabel = item.dataset.soldOutLabel || 'Leider ausverkauft';

    if (!checkStock || !handle) {
      showGratisLinkModal(item);
      return;
    }

    checkProductSoldOut(handle).then(function (soldOut) {
      if (soldOut) {
        showSoldOutOverlay(soldOutLabel);
      } else {
        showGratisLinkModal(item);
      }
    });
  }

  function showSoldOutOverlay(message) {
    var section = getSection();
    var accent  = '#c87759';
    if (section) {
      var cs = getComputedStyle(section);
      accent = cs.getPropertyValue('--hf-gp-accent').trim() || accent;
    }
    document.body.style.overflow = 'hidden';
    var overlay = document.createElement('div');
    overlay.id  = 'hf-gp-soldout-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(255,255,255,0.97);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);z-index:9999990;display:flex;align-items:center;justify-content:center;font-family:inherit;padding:16px;box-sizing:border-box;';
    var box = document.createElement('div');
    box.style.cssText = 'position:relative;background:#fff;padding:40px 32px;border-radius:16px;box-shadow:0 16px 40px rgba(0,0,0,0.16);text-align:center;max-width:360px;width:100%;font-family:inherit;';
    var closeBtn = document.createElement('button');
    closeBtn.innerHTML = '&#10005;';
    closeBtn.style.cssText = 'position:absolute;top:12px;right:14px;background:rgba(0,0,0,0.06);border:none;font-size:14px;line-height:1;cursor:pointer;color:#666;padding:5px 7px;border-radius:6px;font-family:inherit;';
    closeBtn.onclick = function () { overlay.remove(); document.body.style.overflow = ''; };
    box.appendChild(closeBtn);
    var icon = document.createElement('div');
    icon.textContent = '\uD83D\uDE14';
    icon.style.cssText = 'font-size:2.8rem;margin-bottom:14px;';
    box.appendChild(icon);
    var msg = document.createElement('p');
    msg.textContent = message;
    msg.style.cssText = 'margin:0;font-size:1.05rem;font-weight:600;color:#333;line-height:1.4;font-family:inherit;';
    box.appendChild(msg);
    overlay.appendChild(box);
    overlay.addEventListener('click', function (e) {
      if (e.target !== overlay) return;
      overlay.remove();
      document.body.style.overflow = '';
    });
    document.body.appendChild(overlay);
  }

  // ─── Custom-Link Modal ─────────────────────────────────────────────────
  function showGratisLinkModal(item) {
    if (window.Shopify && window.Shopify.designMode) return;
    var variantId    = parseInt(item.dataset.variantId, 10);
    var productId    = item.dataset.productId || '';
    var minDisplay   = item.dataset.minDisplay || '';
    var maxQty       = parseInt(item.dataset.maxQty, 10) || 1;
    var freeLabel    = item.dataset.freeLabel || 'GRATIS';
    var discCode     = item.dataset.discountCode || '';
    var target       = item.dataset.customLinkTarget || 'cart';
    var showQty      = item.dataset.customLinkShowQty === 'true';
    var title        = item.dataset.productTitle || '';
    var imgUrl       = item.dataset.productImg || '';

    // Varianten aus JSON-Block
    var variants = null;
    var dataEl = item.querySelector('.hf-gp-variants-data');
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch(e) {} }

    // CSS-Variablen aus der Section
    var section = getSection();
    var accent  = '#c87759';
    var radius  = '8px';
    if (section) {
      var cs = getComputedStyle(section);
      accent = cs.getPropertyValue('--hf-gp-accent').trim() || accent;
      var br = cs.getPropertyValue('--hf-gp-btn-radius').trim();
      if (br) radius = br;
    }

    document.body.style.overflow = 'hidden';

    var overlay = document.createElement('div');
    overlay.id  = 'hf-gp-link-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.50);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);z-index:9999990;display:flex;align-items:center;justify-content:center;font-family:inherit;padding:16px;box-sizing:border-box;';

    var box = document.createElement('div');
    box.style.cssText = 'position:relative;background:#fff;padding:28px 24px 22px;border-radius:16px;box-shadow:0 16px 40px rgba(0,0,0,0.16);text-align:center;max-width:420px;width:100%;font-family:inherit;max-height:90vh;overflow-y:auto;';

    // ── Schließen-Button ──
    var closeBtn = document.createElement('button');
    closeBtn.innerHTML = '&#10005;';
    closeBtn.style.cssText = 'position:absolute;top:12px;right:14px;background:rgba(0,0,0,0.06);border:none;font-size:14px;line-height:1;cursor:pointer;color:#666;padding:5px 7px;border-radius:6px;font-family:inherit;';
    closeBtn.onclick = function() {
      overlay.remove();
      document.body.style.overflow = '';
      // Zurück zur vorherigen Seite (weg von der 404-URL)
      if (window.history.length > 1) { window.history.back(); }
      else { window.location.href = '/'; }
    };
    box.appendChild(closeBtn);

    // ── Produktbild ──
    if (imgUrl) {
      var img = document.createElement('img');
      img.src = imgUrl;
      img.style.cssText = 'width:100%;height:auto;max-height:260px;object-fit:contain;border-radius:10px;margin-bottom:14px;display:block;';
      box.appendChild(img);
    }

    // ── Produkttitel ──
    if (title) {
      var titleEl = document.createElement('h2');
      titleEl.textContent = title;
      titleEl.style.cssText = 'margin:0 0 10px;font-size:1.05rem;font-weight:700;color:inherit;line-height:1.3;font-family:inherit;';
      box.appendChild(titleEl);
    }

    // ── GRATIS-Badge + "ab X€" ──
    var priceWrap = document.createElement('div');
    priceWrap.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:16px;flex-wrap:wrap;';
    var badge = document.createElement('span');
    badge.style.cssText = 'background:' + accent + ';color:#fff;border-radius:4px;padding:3px 10px;font-size:0.82rem;font-weight:700;letter-spacing:0.03em;white-space:nowrap;display:inline-flex;align-items:center;gap:5px;';
    var badgeMain = document.createElement('span');
    badgeMain.textContent = freeLabel;
    badge.appendChild(badgeMain);
    if (minDisplay) {
      var badgeSub = document.createElement('span');
      badgeSub.style.cssText = 'font-size:0.82rem;font-weight:700;letter-spacing:0.03em;';
      badgeSub.textContent = 'ab\u00a0' + minDisplay;
      badge.appendChild(badgeSub);
    }
    priceWrap.appendChild(badge);
    box.appendChild(priceWrap);

    // ── Varianten-Select ──
    var selectedVariantId = variantId;
    if (variants && variants.length > 1) {
      var sel = document.createElement('select');
      sel.style.cssText = 'width:100%;padding:10px 12px;margin-bottom:14px;border:1.5px solid #ddd;border-radius:' + radius + ';font-size:0.88rem;background:#f9f9f9;cursor:pointer;font-family:inherit;';
      var hasFirst = false;
      variants.forEach(function(v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        if (!v.available) {
          opt.textContent = v.title + ' (Ausverkauft)';
          opt.disabled = true;
          opt.style.color = '#aaa';
        } else {
          opt.textContent = v.title;
          if (!hasFirst) { opt.selected = true; selectedVariantId = v.id; hasFirst = true; }
        }
        sel.appendChild(opt);
      });
      sel.addEventListener('change', function() { selectedVariantId = parseInt(sel.value, 10); });
      box.appendChild(sel);
    }

    // ── Mengenauswahl (optional) ──
    var selectedQty = 1;
    if (showQty && maxQty > 1) {
      var qtyWrap = document.createElement('div');
      qtyWrap.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:10px;margin-bottom:14px;';
      var qtyLabel = document.createElement('label');
      qtyLabel.style.cssText = 'font-size:0.83rem;color:#555;font-family:inherit;';
      qtyLabel.textContent = 'Menge:';
      var qtySelect = document.createElement('select');
      qtySelect.style.cssText = 'padding:8px 12px;border:1.5px solid #ddd;border-radius:' + radius + ';font-size:0.88rem;background:#f9f9f9;cursor:pointer;font-family:inherit;';
      for (var q = 1; q <= maxQty; q++) {
        var qOpt = document.createElement('option');
        qOpt.value = q; qOpt.textContent = q;
        qtySelect.appendChild(qOpt);
      }
      qtySelect.addEventListener('change', function() { selectedQty = parseInt(qtySelect.value, 10); });
      qtyWrap.appendChild(qtyLabel); qtyWrap.appendChild(qtySelect);
      box.appendChild(qtyWrap);
    }

    // ── Hinzufügen-Button ──
    var addBtnEl  = item.querySelector('.hf-gp-item__add-btn-text');
    var addLabel  = (addBtnEl && addBtnEl.textContent.trim()) || 'Gratis hinzufügen';
    var addBtn = document.createElement('button');
    addBtn.textContent = addLabel;
    addBtn.style.cssText = 'width:100%;padding:12px 18px;background:' + accent + ';color:#fff;border:none;border-radius:' + radius + ';font-size:0.92rem;font-weight:600;cursor:pointer;font-family:inherit;transition:opacity 0.2s;';
    addBtn.onmouseover = function() { this.style.opacity = '0.85'; };
    addBtn.onmouseout  = function() { this.style.opacity = '1'; };
    addBtn.onclick = function() {
      if (!selectedVariantId) return;
      addBtn.textContent   = 'Wird hinzugefügt\u2026';
      addBtn.style.opacity = '0.6';
      addBtn.disabled      = true;

      function doRedirect() {
        overlay.remove();
        document.body.style.overflow = '';
        window.location.href = target === 'homepage'
          ? (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/')
          : '/cart';
      }

      fetchCart().then(function(cart) {
        // Bereits im Cart liegende Gratis-Einheiten dieses Produkts zählen (alle Varianten)
        var cartQty = 0;
        (cart.items || []).forEach(function(ci) {
          var p = ci.properties || {};
          if ((p['_free_gift'] || p._free_gift) && String(ci.product_id) === productId) {
            cartQty += ci.quantity;
          }
        });

        if (cartQty >= maxQty) {
          // Limit bereits erreicht – direkt zum Ziel weiterleiten
          addBtn.textContent   = 'Bereits im Warenkorb \u2713';
          addBtn.style.opacity = '1';
          setTimeout(doRedirect, 1000);
          return;
        }

        var qtyToAdd = Math.min(selectedQty, maxQty - cartQty);
        addToCartAPI(selectedVariantId, qtyToAdd, { _free_gift: 'true' })
          .then(function() {
            if (discCode) applyDiscountCode(discCode);
            doRedirect();
          })
          .catch(function() {
            addBtn.textContent   = 'Fehler \u2013 bitte nochmal';
            addBtn.style.opacity = '1';
            addBtn.disabled      = false;
          });
      }).catch(function() {
        addBtn.textContent   = 'Fehler \u2013 bitte nochmal';
        addBtn.style.opacity = '1';
        addBtn.disabled      = false;
      });
    };
    box.appendChild(addBtn);

    overlay.appendChild(box);
    overlay.addEventListener('click', function(e) {
      if (e.target !== overlay) return;
      overlay.remove();
      document.body.style.overflow = '';
      if (window.history.length > 1) { window.history.back(); }
      else { window.location.href = '/'; }
    });

    function mountModal() {
      document.body.appendChild(overlay);
      // Seite wieder sichtbar machen – das Overlay deckt die 404-Seite vollständig ab
      document.documentElement.style.visibility = '';
      document.documentElement.style.opacity    = '';
    }

    if (document.body) { mountModal(); }
    else { document.addEventListener('DOMContentLoaded', mountModal); }
  }

  function initCustomLinks() {
    if (window.Shopify && window.Shopify.designMode) return;
    var section = getSection();
    if (!section) return;
    var currentPath   = window.location.pathname.toLowerCase();
    if (currentPath.length > 1 && currentPath.endsWith('/')) currentPath = currentPath.slice(0, -1);
    var urlParams = null;
    try { urlParams = new URLSearchParams(window.location.search); } catch(e) {}

    section.querySelectorAll('.hf-gp-item').forEach(function(item) {
      var triggered = false;

      var paramKey    = (item.dataset.customLinkParam || '').trim();
      var productHandle = (item.dataset.productHandle || '').trim();

      // Variante A: Pfad-Trigger → sofort zur Produktseite weiterleiten
      // Die Produktseite hat echte OG-Tags → schöne Link-Preview in WhatsApp/Instagram
      var trigger = (item.dataset.customLink || '').trim().toLowerCase();
      if (trigger) {
        if (trigger.charAt(0) !== '/') trigger = '/' + trigger;
        trigger = trigger.replace(/\/+/g, '/');
        if (trigger.length > 1 && trigger.endsWith('/')) trigger = trigger.slice(0, -1);
        if (currentPath === trigger) {
          // Redirect-Ziel aus Data-Attribut auslesen (homepage / cart / product_page)
          var triggerRedirect = (item.dataset.customLinkTriggerRedirect || 'product_page').trim();
          var redirectParam   = paramKey || 'hfgratis';
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          var destUrl = null;
          if (triggerRedirect === 'homepage') {
            destUrl = root + '?' + encodeURIComponent(redirectParam);
          } else if (triggerRedirect === 'cart') {
            destUrl = root + 'cart?' + encodeURIComponent(redirectParam);
          } else if (productHandle) {
            destUrl = root + 'products/' + encodeURIComponent(productHandle) + '?' + encodeURIComponent(redirectParam);
          }
          if (destUrl) {
            document.documentElement.style.visibility = 'hidden';
            document.documentElement.style.opacity    = '0';
            window.location.replace(destUrl);
            return; // Seite wechselt – nichts weiter tun
          }
          // Kein Handle bekannt → Modal direkt auf 404 zeigen (Fallback)
          triggered = true;
        }
      }

      // Variante B: URL-Parameter (z.B. ?gratis auf Produktseite/Homepage)
      if (!triggered && urlParams && paramKey) {
        if (urlParams.has(paramKey)) triggered = true;
      }
      // Fallback-Parameter für automatischen Redirect (Variante A ohne eigenen Param)
      if (!triggered && urlParams) {
        if (urlParams.has('hfgratis')) triggered = true;
      }

      if (!triggered) return;

      var productTitle = item.dataset.productTitle || '';
      document.title = productTitle || 'Einen Moment bitte\u2026';

      openGratisModal(item);
    });
  }

  // ─── Produktseiten-Sperre ───────────────────────────────────────────────
  // Einmalig registrierter Event-Delegator – fängt Klicks auf alle Links zu
  // gesperrten Produkt-Handles ab, egal wo im DOM sie auftauchen.
  function initProductLinkBlocker() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var m = href.match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var handle = m[1].toLowerCase();
      var section = getSection();
      if (!section) return;
      var blocked = false;
      section.querySelectorAll('.hf-gp-item[data-block-product-link="true"]').forEach(function (item) {
        if ((item.dataset.productHandle || '').toLowerCase() === handle) blocked = true;
      });
      if (!blocked) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  // ─── Init ──────────────────────────────────────────────────────────────
  function init() {
    if (!getSection()) return;
    initInterceptors();
    initProductLinkBlocker();
    initDOMWatcher();
    initVariantSelectors();
    initPopup();
    initCustomLinks();
    hideListingProducts();
    fetchCart().then(function (cart) {
      lastCartFP = cart.total_price + '|' + cart.item_count;
      updateSection(cart);
      bindAddButtons();
    });
    // Cart-Events: immer frisch von der API holen – Theme-Events liefern
    // oft vereinfachte Cart-Objekte ohne item.properties → freeGiftKeys wäre leer.
    ['cart:updated', 'cart:refresh'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        fetchCart().then(updateSection);
      });
    });

    // Alle Cart-Modifikationen direkt abfangen: qty-Änderung, Entfernen-Button, Cart-Form-Submit.
    // Themes feuern cart:updated oft erst nach dem Ajax-Response, der Re-Render
    // kann früher passieren – daher eigene verzögerte Fetches als Sicherheitsnetz.
    function scheduleCartRefresh() {
      setTimeout(function () { fetchCart().then(updateSection); }, 500);
      setTimeout(function () { fetchCart().then(updateSection); }, 1200);
      setTimeout(function () { fetchCart().then(updateSection); }, 2200);
    }

    // qty-Input-Änderungen (Mengenfeld im Cart/Drawer)
    document.addEventListener('change', function (e) {
      var inp = e.target;
      if (!inp || inp.type !== 'number') return;
      if (!inp.closest('[data-key], [data-cart-item-key], [data-line-item-key], [class*="cart"], [class*="drawer"]')) return;
      scheduleCartRefresh();
    });

    // Entfernen-Buttons / Delete-Icons im Cart/Drawer
    document.addEventListener('click', function (e) {
      var btn = e.target.closest(
        'button[name="remove"], [class*="remove"], [class*="delete"], ' +
        '[aria-label*="entfern"], [aria-label*="remov"], [aria-label*="delet"], ' +
        'a[href*="/cart/change"], button[data-line]'
      );
      if (!btn) return;
      if (!btn.closest('[data-key], [data-cart-item-key], [class*="cart"], [class*="drawer"]')) return;
      scheduleCartRefresh();
    });

    // Cart-Form-Submits (manche Themes nutzen POST /cart/update)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action) return;
      if (form.action.indexOf('/cart') === -1) return;
      scheduleCartRefresh();
    }, true);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-main-collection"] && !Shopify.designMode) return;
  try {
    
    /* ── Hash-Scroll ── */
    const url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) card.scrollIntoView({ behavior: 'instant' });
        },
        { once: true }
      );
    }
  
    /* ── Grid-Bild Zeilen-Fix (Links / Rechts fixieren) ──────────────────────
       Problem: CSS Grid setzt explizit positionierte Items (grid-column-start/end)
       VOR auto-platzierten Items – unabhängig von der DOM-Reihenfolge. Dadurch
       landet das Bild visuell in der falschen Zeile.
       Fix: Wir berechnen die "natürliche" Zeile anhand der DOM-Position und setzen
       grid-row explizit, sodass das Bild in seiner richtigen Zeile bleibt.
    ────────────────────────────────────────────────────────────────────────── */
    (function () {
      function getColCount(grid) {
        var attr = parseInt(grid.getAttribute('data-hf-cols'), 10);
        if (attr > 0) return attr;
        var tc = window.getComputedStyle(grid).getPropertyValue('grid-template-columns');
        if (!tc || tc === 'none') return 0;
        return tc.trim().split(/\s+/).filter(function (s) { return s.length > 0; }).length;
      }
  
      function fixAlignedGridImages() {
        document.querySelectorAll('.product-grid').forEach(function (grid) {
          var cols = getColCount(grid);
          if (!cols) return;
  
          var pos = 0; /* linearer Zellenindex (0-basiert) */
  
          Array.from(grid.children).forEach(function (item) {
            var isLeft   = item.classList.contains('hf-align-left');
            var isRight  = item.classList.contains('hf-align-right');
            /* Desktop-Dimensionen; Mobile übernimmt CSS-Klassen */
            var colSpan  = item.classList.contains('hf-col-span-2') ? 2 : 1;
            /* Row-Span muss in gridRow-Shorthand eingebaut werden,
               da inline-style das CSS-Klassen-Span überschreibt. */
            var rowSpan  = item.classList.contains('hf-row-span-2') ? 2 : 1;
            var colInRow = pos % cols;
  
            if (isLeft) {
              /* Links: muss an Spalte 1 stehen → ggf. in nächste Zeile springen */
              if (colInRow !== 0) pos += cols - colInRow;
              var rowStart = Math.floor(pos / cols) + 1;
              item.style.gridRow = rowSpan > 1
                ? (rowStart + ' / span ' + rowSpan)
                : String(rowStart);
              pos += colSpan;
  
            } else if (isRight) {
              /* Rechts: letzte colSpan Spalten → ggf. in nächste Zeile springen */
              if (colInRow + colSpan > cols) pos += cols - colInRow;
              var rowStart = Math.floor(pos / cols) + 1;
              item.style.gridRow = rowSpan > 1
                ? (rowStart + ' / span ' + rowSpan)
                : String(rowStart);
              pos += colSpan;
  
            } else {
              item.style.gridRow = '';
              pos += colSpan;
            }
          });
        });
      }
  
      document.addEventListener('DOMContentLoaded', fixAlignedGridImages);
      document.addEventListener('shopify:section:load', fixAlignedGridImages);
  
      /* ── Spalten-Umschalter ── */
      function initColSwitchers() {
        document.querySelectorAll('.hf-col-switcher-bar[data-section-id]').forEach(function (switcher) {
          if (switcher.dataset.initialized) return;
          switcher.dataset.initialized = 'true';
  
          const sectionId = switcher.dataset.sectionId;
          const storageKey = 'hf-cols-' + sectionId;
          const grid = document.querySelector('.product-grid--' + sectionId);
  
          if (!grid) return;
  
          function triggerGridAnimation() {
            /* Klasse entfernen → Reflow erzwingen → wieder drauf: Browser startet Keyframe neu */
            grid.classList.remove('hf-grid-animating');
            Array.from(grid.children).forEach(function (item, idx) {
              /* Stagger auf max. 15 gedeckelt → letztes Delay = 15 × 50 ms = 750 ms */
              item.style.setProperty('--hf-item-idx', Math.min(idx, 15));
            });
            /* eslint-disable-next-line no-void */
            void grid.offsetWidth; /* Force reflow */
            grid.classList.add('hf-grid-animating');

            /* Klasse nach Ablauf aller Animationen aufräumen */
            clearTimeout(grid._hfAnimTimer);
            grid._hfAnimTimer = setTimeout(function () {
              grid.classList.remove('hf-grid-animating');
            }, 750 + 250 + 50 /* max-delay + duration + puffer */);
          }

          function setActive(cols, animate) {
            grid.setAttribute('data-hf-cols', cols);
            switcher.querySelectorAll('.hf-col-btn').forEach(function (b) {
              b.classList.toggle('is-active', b.dataset.cols === String(cols));
            });
            /* Zeilenkorrektur nach Spaltenänderung neu berechnen */
            requestAnimationFrame(fixAlignedGridImages);
            if (animate) triggerGridAnimation();
          }

          const stored = sessionStorage.getItem(storageKey);
          if (stored) setActive(stored, false);

          switcher.querySelectorAll('.hf-col-btn').forEach(function (btn) {
            btn.addEventListener('click', function () {
              const cols = btn.dataset.cols;
              setActive(cols, true);
              sessionStorage.setItem(storageKey, cols);
            });
          });
        });
      }
  
      document.addEventListener('DOMContentLoaded', initColSwitchers);
      document.addEventListener('shopify:section:load', initColSwitchers);

      /* ── Entrance-Animation beim ersten Laden ──
         data-hf-entrance hält Items per CSS auf opacity:0 bis dieser Block läuft.
         Attribut und Klasse werden in einem Zug gesetzt → kein Flash.        */
      function initGridEntranceAnimations() {
        document.querySelectorAll('results-list[data-hf-entrance]').forEach(function (container) {
          var sectionId = container.getAttribute('section-id');
          var grid = container.querySelector('.product-grid--' + sectionId);
          if (!grid) return;

          /* Indizes setzen während Items noch versteckt sind */
          Array.from(grid.children).forEach(function (item, idx) {
            item.style.setProperty('--hf-item-idx', Math.min(idx, 15));
          });

          /* Attribut entfernen + Animationsklasse setzen = ein Browser-Zug, kein Zwischenpaint */
          container.removeAttribute('data-hf-entrance');
          grid.classList.add('hf-grid-animating');

          clearTimeout(grid._hfAnimTimer);
          grid._hfAnimTimer = setTimeout(function () {
            grid.classList.remove('hf-grid-animating');
          }, 750 + 250 + 50);
        });
      }

      document.addEventListener('DOMContentLoaded', initGridEntranceAnimations);
      document.addEventListener('shopify:section:load', function () {
        /* Bei section:load das Attribut neu setzen damit die Animation erneut spielt */
        document.querySelectorAll('results-list[section-id]').forEach(function (c) {
          c.setAttribute('data-hf-entrance', '');
        });
        initGridEntranceAnimations();
      });

      /* ── Ab-Preis (Variantenpreise) – nur diese Section, kein Theme-Block nötig ── */
      function applyHfFromPrices(container) {
        if (!container || container.getAttribute('data-hf-show-from-price') !== 'true') return;

        container.querySelectorAll('.product-grid__item[data-hf-from-price]').forEach(function (item) {
          if (item.getAttribute('data-hf-from-price-applied') === 'true') return;

          var label = item.getAttribute('data-hf-from-price');
          if (!label) return;

          var priceRoot = item.querySelector('product-price');
          if (!priceRoot) return;

          var priceContainer = priceRoot.querySelector('[ref="priceContainer"]') || priceRoot;
          var volumeNote = priceRoot.querySelector('.volume-pricing-note');

          priceContainer.innerHTML = '';
          var span = document.createElement('span');
          span.className = 'price hf-price-from-' + container.getAttribute('section-id');
          span.textContent = label;
          priceContainer.appendChild(span);

          if (volumeNote) volumeNote.remove();
          item.setAttribute('data-hf-from-price-applied', 'true');
        });
      }

      function initHfFromPrices() {
        document.querySelectorAll('results-list[data-hf-show-from-price="true"]').forEach(function (container) {
          applyHfFromPrices(container);

          var sectionId = container.getAttribute('section-id');
          var grid = container.querySelector('.product-grid--' + sectionId);
          if (!grid || grid.getAttribute('data-hf-from-price-observed') === 'true') return;

          grid.setAttribute('data-hf-from-price-observed', 'true');
          new MutationObserver(function () {
            applyHfFromPrices(container);
          }).observe(grid, { childList: true });
        });
      }

      document.addEventListener('DOMContentLoaded', initHfFromPrices);
      document.addEventListener('shopify:section:load', initHfFromPrices);
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
